import { render, staticRenderFns } from "./orgaoVinculado.vue?vue&type=template&id=4cca81ba&"
import script from "./orgaoVinculado.vue?vue&type=script&lang=js&"
export * from "./orgaoVinculado.vue?vue&type=script&lang=js&"
import style0 from "./orgaoVinculado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports